/* esm.sh - applesauce-core@5.2.0/dist/helpers/event */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/event.mjs";
